export default "__VITE_ASSET__DUHmdyfE__"